webpackJsonp([81],{

/***/ 124:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//

window.videojs = __webpack_require__(90);
__webpack_require__(75);
var languages = __webpack_require__(209);
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'video-player',
  props: {
    options: {
      type: Object,
      required: true
    }
  },
  mounted: function mounted() {
    if (!this.player) {
      this.initialize();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.player) {
      this.dispose();
    }
  },

  methods: {
    initialize: function initialize() {

      // init
      var self = this;
      this.player = null;

      // options
      var videoOptions = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({

        // component options
        start: 0,
        playsinline: false,
        customEventName: 'statechanged',

        // videojs options
        autoplay: false,
        controls: true,
        preload: 'auto',
        fluid: false,
        muted: false,
        width: '100%',
        height: '360',
        language: 'en',
        controlBar: {
          remainingTimeDisplay: false,
          playToggle: {},
          progressControl: {},
          fullscreenToggle: {},
          volumeMenuButton: {
            inline: false,
            vertical: true
          }
        },
        techOrder: ['html5', 'flash'],
        playbackRates: [],
        plugins: {}
      }, this.options);

      // check sources
      /*
      if (!videoOptions.sources || !videoOptions.sources.length) {
        console.warn('Missing required option: "sources".')
        return false
      }
      */

      // add language
      var language = videoOptions.language;
      videojs.addLanguage(language, languages[language]);

      // ios fullscreen
      var playsinline = videoOptions.playsinline;
      if (playsinline) {
        this.$el.children[0].setAttribute('playsinline', playsinline);
        this.$el.children[0].setAttribute('webkit-playsinline', playsinline);
      }

      // emit event
      var emitPlayerState = function emitPlayerState(event, value) {
        if (event) {
          self.$emit(event, self.player);
        }
        if (value) {
          var values = {};
          values[event] = value;
          self.$emit(videoOptions.customEventName, values);
        }
      };

      // videoOptions
      // console.log(videoOptions)

      // avoid error "VIDEOJS: ERROR: Unable to find plugin: __ob__"
      if (videoOptions.plugins) {
        delete videoOptions.plugins.__ob__;
      }
      this.player = videojs(this.$el.children[0], videoOptions, function () {

        // player readied
        self.$emit('ready', self.player);

        this.on('loadeddata', function () {
          this.muted(videoOptions.muted);
          if (!!videoOptions.start) {
            this.currentTime(videoOptions.start);
          }
          emitPlayerState('loadeddata', true);
        });

        this.on('canplay', function () {
          emitPlayerState('canplay', true);
        });

        this.on('canplaythrough', function () {
          emitPlayerState('canplaythrough', true);
        });

        this.on('play', function () {
          emitPlayerState('play', true);
        });

        this.on('pause', function () {
          emitPlayerState('pause', true);
        });

        this.on('waiting', function () {
          emitPlayerState('waiting', true);
        });

        this.on('playing', function () {
          emitPlayerState('playing', true);
        });

        this.on('ended', function () {
          emitPlayerState('ended', true);
        });

        this.on('timeupdate', function () {
          emitPlayerState('timeupdate', this.currentTime());
        });
      });
    },
    dispose: function dispose() {
      if (this.player && videojs) {
        this.player.pause && this.player.pause();
        videojs(this.$el.children[0]).dispose();
        if (!this.$el.children.length) {
          var video = document.createElement('video');
          video.className = 'video-js vjs-custom-skin';
          this.$el.appendChild(video);
        }
        this.player = null;
      }
    }
  },
  watch: {
    options: {
      deep: true,
      handler: function handler(options, oldOptions) {
        this.dispose();
        if (options && options.sources && options.sources.length) {
          this.initialize();
        }
      }
    }
  }
});

/***/ }),

/***/ 125:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_warn__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_warn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_common_warn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_loading__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_common_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_base_js__ = __webpack_require__(99);
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app',
    components: {
        warnBox: __WEBPACK_IMPORTED_MODULE_0__components_common_warn___default.a,
        loading: __WEBPACK_IMPORTED_MODULE_1__components_common_loading___default.a
    },
    created: function created() {
        this.isWx();
        this.getData();
    },

    methods: {
        getData: function getData() {
            if (!sessionStorage.getItem('uuid')) {
                __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('/getUuid.html', {}, __WEBPACK_IMPORTED_MODULE_3__api_base_js__["a" /* default */]).then(function (res) {
                    sessionStorage.setItem("uuid", res.data.uuid);
                });
            }
        },
        isWx: function isWx() {
            var ua = window.navigator.userAgent.toLowerCase();
            if (ua.match(/MicroMessenger/i) == 'micromessenger') {
                sessionStorage.setItem('isWx', 'true');
            } else {
                sessionStorage.setItem('isWx', 'false');
            }
        }
    }
});

/***/ }),

/***/ 126:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//

// ******默认url链接********
// var urlBase="http://192.168.1.103:8082/"; //168
//	var urlBase="http://192.168.1.192:8080/api";   //陈勇
//var urlBase="http://110.cs.gc80.cn";   //陈勇
var urlBase = "https://m-jxjy.18jobs.com/api"; //正式
// var urlBase="http://weixin.ahsjxjy.com/api";          //微信测试

// ******图片链接********
var imgBase = "https://www.ahsjxjy.com";

/* harmony default export */ __webpack_exports__["default"] = ({
  urlBase: urlBase,
  imgBase: imgBase
});

/***/ }),

/***/ 127:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mint_ui__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_video_js_dist_video_js_css__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_video_js_dist_video_js_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_video_js_dist_video_js_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mint_ui_lib_style_css__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mint_ui_lib_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_mint_ui_lib_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_video_player__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_video_player___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_video_player__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_index__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_global_vue__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_global_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_global_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_jquery__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_jquery__);












//import 'bootstrap/dist/css/bootstrap.min.css'
//import 'bootstrap/dist/js/bootstrap.min'
// title值绑定
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].directive('title', {
    inserted: function inserted(el, binding) {
        document.title = el.dataset.title;
    }
});

__WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].afterEach(function (to, from, next) {
    __WEBPACK_IMPORTED_MODULE_11_jquery___default()('body,html,.main').scrollTop('0');
});

// 引入全局变量
// 全局变量模块挂载到Vue.prototype
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.GLOBAL = __WEBPACK_IMPORTED_MODULE_10__components_global_vue___default.a;

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_video_player___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_mint_ui___default.a);

// request请求拦截器
__WEBPACK_IMPORTED_MODULE_4_axios___default.a.interceptors.request.use(function (config) {
    // 判断是否存在token，如果存在的话，则每个request header都加上token
    if (localStorage.getItem('jxjy_token')) {
        config.headers.Authorization = localStorage.getItem('jxjy_token');
    };

    // 判断是否在微信
    if (window.navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == 'micromessenger') {
        //微信
        config.headers.equipment = '04';
    } else {
        // 浏览器
        config.headers.equipment = '02';
    }

    // 判断是否存在uuid，如果存在，每个request header就加上uuid
    if (sessionStorage.getItem('uuid')) {
        config.headers.uuid = sessionStorage.getItem('uuid');
    };

    // 发起请求时等待的弹框
    // $("#"+vm.$el.lastChild.previousElementSibling.id).fadeIn();

    return config;
}, function (err) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
});

// response响应拦截器
__WEBPACK_IMPORTED_MODULE_4_axios___default.a.interceptors.response.use(function (response) {
    if (response.data.result == "-1") {
        // token过期或者无效跳转到登录页,然后跳回原页面
        vm.$router.push({ path: '/login', query: { 'redirect': vm.$route.fullPath } });
    } else {
        // 如果token未过期且返回值token存在就更新token
        if (response.data.token != "" && response.data.token != undefined && response.data.token != null) {
            localStorage.setItem('jxjy_token', response.data.token);
        };
    };

    // 判断响应状态码，若是响应成功，那么将弹框隐藏
    var a = response.status;
    if (a == '200') {
        var timer = setTimeout(function () {
            __WEBPACK_IMPORTED_MODULE_11_jquery___default()("#" + vm.$el.lastChild.previousElementSibling.id).fadeOut();
        }, 500);
    }

    return response;
}, function (err) {
    if (err.message = 'Network Error') {
        // 提示接口异常
        __WEBPACK_IMPORTED_MODULE_11_jquery___default()("#" + vm.$el.lastChild.previousElementSibling.id).fadeOut(100);
        __WEBPACK_IMPORTED_MODULE_11_jquery___default()("#" + vm.$el.lastChild.id).fadeIn();
        var timer = setTimeout(function () {
            __WEBPACK_IMPORTED_MODULE_11_jquery___default()("#" + vm.$el.lastChild.id).fadeOut();
        }, 2000);
    }
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
});

var vm = new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
    store: __WEBPACK_IMPORTED_MODULE_9__store_index__["a" /* default */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a }
}).$mount('#app');

/***/ }),

/***/ 163:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 164:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 165:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 170:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(165)
}
var Component = __webpack_require__(19)(
  /* script */
  __webpack_require__(124),
  /* template */
  __webpack_require__(176),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 171:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(163)
}
var Component = __webpack_require__(19)(
  /* script */
  null,
  /* template */
  __webpack_require__(173),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0eeacf99",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 172:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(164)
}
var Component = __webpack_require__(19)(
  /* script */
  null,
  /* template */
  __webpack_require__(174),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-427e3679",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 173:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "loading"
    }
  }, [_c('div', {
    staticClass: "loading_pool"
  }), _vm._v(" "), _c('div', {
    staticClass: "loading_box"
  }, [_c('div', {
    staticClass: "loading"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/loading.png",
      "alt": "远创专技教育网"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "loading_text"
  }, [_vm._v("加载中...")])])])])
}]}

/***/ }),

/***/ 174:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "warn_alert"
    }
  }, [_c('div', {
    staticClass: "pool"
  }), _vm._v(" "), _c('div', {
    staticClass: "warn_box"
  }, [_c('div', {
    staticClass: "warn"
  }, [_vm._v("服务异常，请稍后再试")])])])
}]}

/***/ }),

/***/ 175:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view'), _vm._v(" "), _c('loading', {
    ref: "loading"
  }), _vm._v(" "), _c('warnBox', {
    ref: "warn_box"
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 176:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-player"
  }, [_c('video', {
    staticClass: "video-js vjs-custom-skin"
  })])
}]}

/***/ }),

/***/ 179:
/***/ (function(module, exports) {

module.exports = {
	"Play": "تشغيل",
	"Pause": "ايقاف",
	"Current Time": "الوقت الحالي",
	"Duration Time": "Dauer",
	"Remaining Time": "الوقت المتبقي",
	"Stream Type": "نوع التيار",
	"LIVE": "مباشر",
	"Loaded": "تم التحميل",
	"Progress": "التقدم",
	"Fullscreen": "ملء الشاشة",
	"Non-Fullscreen": "غير ملء الشاشة",
	"Mute": "صامت",
	"Unmute": "غير الصامت",
	"Playback Rate": "معدل التشغيل",
	"Subtitles": "الترجمة",
	"subtitles off": "ايقاف الترجمة",
	"Captions": "التعليقات",
	"captions off": "ايقاف التعليقات",
	"Chapters": "فصول",
	"You aborted the media playback": "لقد ألغيت تشغيل الفيديو",
	"A network error caused the media download to fail part-way.": "تسبب خطأ في الشبكة بفشل تحميل الفيديو بالكامل.",
	"The media could not be loaded, either because the server or network failed or because the format is not supported.": "لا يمكن تحميل الفيديو بسبب فشل في الخادم أو الشبكة ، أو فشل بسبب عدم امكانية قراءة تنسيق الفيديو.",
	"The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "تم ايقاف تشغيل الفيديو بسبب مشكلة فساد أو لأن الفيديو المستخدم يستخدم ميزات غير مدعومة من متصفحك.",
	"No compatible source was found for this media.": "فشل العثور على أي مصدر متوافق مع هذا الفيديو.",
	"Play Video": "تشغيل الفيديو",
	"Close": "أغلق",
	"Modal Window": "نافذة مشروطة",
	"This is a modal window": "هذه نافذة مشروطة",
	"This modal can be closed by pressing the Escape key or activating the close button.": "يمكن غلق هذه النافذة المشروطة عن طريق الضغط على زر الخروج أو تفعيل زر الإغلاق",
	", opens captions settings dialog": ", تفتح نافذة  خيارات التعليقات",
	", opens subtitles settings dialog": ", تفتح نافذة  خيارات الترجمة",
	", selected": ", مختار"
};

/***/ }),

/***/ 180:
/***/ (function(module, exports) {

module.exports = {
	"Play": "Възпроизвеждане",
	"Pause": "Пауза",
	"Current Time": "Текущо време",
	"Duration Time": "Продължителност",
	"Remaining Time": "Оставащо време",
	"Stream Type": "Тип на потока",
	"LIVE": "НА ЖИВО",
	"Loaded": "Заредено",
	"Progress": "Прогрес",
	"Fullscreen": "Цял екран",
	"Non-Fullscreen": "Спиране на цял екран",
	"Mute": "Без звук",
	"Unmute": "Със звук",
	"Playback Rate": "Скорост на възпроизвеждане",
	"Subtitles": "Субтитри",
	"subtitles off": "Спряни субтитри",
	"Captions": "Аудио надписи",
	"captions off": "Спряни аудио надписи",
	"Chapters": "Глави",
	"You aborted the media playback": "Спряхте възпроизвеждането на видеото",
	"A network error caused the media download to fail part-way.": "Грешка в мрежата провали изтеглянето на видеото.",
	"The media could not be loaded, either because the server or network failed or because the format is not supported.": "Видеото не може да бъде заредено заради проблем със сървъра или мрежата или защото този формат не е поддържан.",
	"The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "Възпроизвеждането на видеото беше прекъснато заради проблем с файла или защото видеото използва опции които браузърът Ви не поддържа.",
	"No compatible source was found for this media.": "Не беше намерен съвместим източник за това видео."
};

/***/ }),

/***/ 181:
/***/ (function(module, exports) {

module.exports = {
	"Play": "Reproducció",
	"Pause": "Pausa",
	"Current Time": "Temps reproduït",
	"Duration Time": "Durada total",
	"Remaining Time": "Temps restant",
	"Stream Type": "Tipus de seqüència",
	"LIVE": "EN DIRECTE",
	"Loaded": "Carregat",
	"Progress": "Progrés",
	"Fullscreen": "Pantalla completa",
	"Non-Fullscreen": "Pantalla no completa",
	"Mute": "Silencia",
	"Unmute": "Amb so",
	"Playback Rate": "Velocitat de reproducció",
	"Subtitles": "Subtítols",
	"subtitles off": "Subtítols desactivats",
	"Captions": "Llegendes",
	"captions off": "Llegendes desactivades",
	"Chapters": "Capítols",
	"You aborted the media playback": "Heu interromput la reproducció del vídeo.",
	"A network error caused the media download to fail part-way.": "Un error de la xarxa ha interromput la baixada del vídeo.",
	"The media could not be loaded, either because the server or network failed or because the format is not supported.": "No s'ha pogut carregar el vídeo perquè el servidor o la xarxa han fallat, o bé perquè el seu format no és compatible.",
	"The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "La reproducció de vídeo s'ha interrumput per un problema de corrupció de dades o bé perquè el vídeo demanava funcions que el vostre navegador no ofereix.",
	"No compatible source was found for this media.": "No s'ha trobat cap font compatible amb el vídeo."
};

/***/ }),

/***/ 182:
/***/ (function(module, exports) {

module.exports = {
	"Play": "Přehrát",
	"Pause": "Pauza",
	"Current Time": "Aktuální čas",
	"Duration Time": "Doba trvání",
	"Remaining Time": "Zbývající čas",
	"Stream Type": "Stream Type",
	"LIVE": "ŽIVĚ",
	"Loaded": "Načteno",
	"Progress": "Stav",
	"Fullscreen": "Celá obrazovka",
	"Non-Fullscreen": "Zmenšená obrazovka",
	"Mute": "Ztlumit zvuk",
	"Unmute": "Přehrát zvuk",
	"Playback Rate": "Rychlost přehrávání",
	"Subtitles": "Titulky",
	"subtitles off": "Titulky vypnuty",
	"Captions": "Popisky",
	"captions off": "Popisky vypnuty",
	"Chapters": "Kapitoly",
	"You aborted the media playback": "Přehrávání videa je přerušeno.",
	"A network error caused the media download to fail part-way.": "Video nemohlo být načteno, kvůli chybě v síti.",
	"The media could not be loaded, either because the server or network failed or because the format is not supported.": "Video nemohlo být načteno, buď kvůli chybě serveru nebo sítě nebo proto, že daný formát není podporován.",
	"The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "Váš prohlížeč nepodporuje formát videa.",
	"No compatible source was found for this media.": "Špatně zadaný zdroj videa."
};

/***/ }),

/***/ 183:
/***/ (function(module, exports) {

module.exports = {
	"Play": "Afspil",
	"Pause": "Pause",
	"Current Time": "Aktuel tid",
	"Duration Time": "Varighed",
	"Remaining Time": "Resterende tid",
	"Stream Type": "Stream-type",
	"LIVE": "LIVE",
	"Loaded": "Indlæst",
	"Progress": "Status",
	"Fullscreen": "Fuldskærm",
	"Non-Fullscreen": "Luk fuldskærm",
	"Mute": "Uden lyd",
	"Unmute": "Med lyd",
	"Playback Rate": "Afspilningsrate",
	"Subtitles": "Undertekster",
	"subtitles off": "Uden undertekster",
	"Captions": "Undertekster for hørehæmmede",
	"captions off": "Uden undertekster for hørehæmmede",
	"Chapters": "Kapitler",
	"You aborted the media playback": "Du afbrød videoafspilningen.",
	"A network error caused the media download to fail part-way.": "En netværksfejl fik download af videoen til at fejle.",
	"The media could not be loaded, either because the server or network failed or because the format is not supported.": "Videoen kunne ikke indlæses, enten fordi serveren eller netværket fejlede, eller fordi formatet ikke er understøttet.",
	"The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "Videoafspilningen blev afbrudt på grund af ødelagte data eller fordi videoen benyttede faciliteter som din browser ikke understøtter.",
	"No compatible source was found for this media.": "Fandt ikke en kompatibel kilde for denne media."
};

/***/ }),

/***/ 184:
/***/ (function(module, exports) {

module.exports = {
	"Play": "Wiedergabe",
	"Pause": "Pause",
	"Current Time": "Aktueller Zeitpunkt",
	"Duration Time": "Dauer",
	"Remaining Time": "Verbleibende Zeit",
	"Stream Type": "Streamtyp",
	"LIVE": "LIVE",
	"Loaded": "Geladen",
	"Progress": "Status",
	"Fullscreen": "Vollbild",
	"Non-Fullscreen": "Kein Vollbild",
	"Mute": "Ton aus",
	"Unmute": "Ton ein",
	"Playback Rate": "Wiedergabegeschwindigkeit",
	"Subtitles": "Untertitel",
	"subtitles off": "Untertitel aus",
	"Captions": "Untertitel",
	"captions off": "Untertitel aus",
	"Chapters": "Kapitel",
	"You aborted the media playback": "Sie haben die Videowiedergabe abgebrochen.",
	"A network error caused the media download to fail part-way.": "Der Videodownload ist aufgrund eines Netzwerkfehlers fehlgeschlagen.",
	"The media could not be loaded, either because the server or network failed or because the format is not supported.": "Das Video konnte nicht geladen werden, da entweder ein Server- oder Netzwerkfehler auftrat oder das Format nicht unterstützt wird.",
	"The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "Die Videowiedergabe wurde entweder wegen eines Problems mit einem beschädigten Video oder wegen verwendeten Funktionen, die vom Browser nicht unterstützt werden, abgebrochen.",
	"No compatible source was found for this media.": "Für dieses Video wurde keine kompatible Quelle gefunden.",
	"Play Video": "Video abspielen",
	"Close": "Schließen",
	"Modal Window": "Modales Fenster",
	"This is a modal window": "Dies ist ein modales Fenster",
	"This modal can be closed by pressing the Escape key or activating the close button.": "Durch Drücken der Esc-Taste bzw. Betätigung der Schaltfläche \"Schließen\" wird dieses modale Fenster geschlossen.",
	", opens captions settings dialog": ", öffnet Einstellungen für Untertitel",
	", opens subtitles settings dialog": ", öffnet Einstellungen für Untertitel",
	", selected": ", ausgewählt",
	"Close Modal Dialog": "Modales Fenster schließen",
	"Descriptions": "Beschreibungen",
	"descriptions off": "Beschreibungen aus",
	"The media is encrypted and we do not have the keys to decrypt it.": "Die Entschlüsselungsschlüssel für den verschlüsselten Medieninhalt sind nicht verfügbar.",
	", opens descriptions settings dialog": ", öffnet Einstellungen für Beschreibungen",
	"Audio Track": "Tonspur"
};

/***/ }),

/***/ 185:
/***/ (function(module, exports) {

module.exports = {
	"Play": "Aναπαραγωγή",
	"Pause": "Παύση",
	"Current Time": "Τρέχων χρόνος",
	"Duration Time": "Συνολικός χρόνος",
	"Remaining Time": "Υπολοιπόμενος χρόνος",
	"Stream Type": "Τύπος ροής",
	"LIVE": "ΖΩΝΤΑΝΑ",
	"Loaded": "Φόρτωση επιτυχής",
	"Progress": "Πρόοδος",
	"Fullscreen": "Πλήρης οθόνη",
	"Non-Fullscreen": "Έξοδος από πλήρη οθόνη",
	"Mute": "Σίγαση",
	"Unmute": "Kατάργηση σίγασης",
	"Playback Rate": "Ρυθμός αναπαραγωγής",
	"Subtitles": "Υπότιτλοι",
	"subtitles off": "απόκρυψη υπότιτλων",
	"Captions": "Λεζάντες",
	"captions off": "απόκρυψη λεζάντων",
	"Chapters": "Κεφάλαια",
	"Close Modal Dialog": "Κλείσιμο παραθύρου",
	"Descriptions": "Περιγραφές",
	"descriptions off": "απόκρυψη περιγραφών",
	"Audio Track": "Ροή ήχου",
	"You aborted the media playback": "Ακυρώσατε την αναπαραγωγή",
	"A network error caused the media download to fail part-way.": "Ένα σφάλμα δικτύου προκάλεσε την αποτυχία μεταφόρτωσης του αρχείου προς αναπαραγωγή.",
	"The media could not be loaded, either because the server or network failed or because the format is not supported.": "Το αρχείο προς αναπαραγωγή δεν ήταν δυνατό να φορτωθεί είτε γιατί υπήρξε σφάλμα στον διακομιστή ή το δίκτυο, είτε γιατί ο τύπος του αρχείου δεν υποστηρίζεται.",
	"The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "Η αναπαραγωγή ακυρώθηκε είτε λόγω κατεστραμμένου αρχείου, είτε γιατί το αρχείο απαιτεί λειτουργίες που δεν υποστηρίζονται από το πρόγραμμα περιήγησης που χρησιμοποιείτε.",
	"No compatible source was found for this media.": "Δεν βρέθηκε συμβατή πηγή αναπαραγωγής για το συγκεκριμένο αρχείο.",
	"The media is encrypted and we do not have the keys to decrypt it.": "Το αρχείο προς αναπαραγωγή είναι κρυπτογραφημένo και δεν υπάρχουν τα απαραίτητα κλειδιά αποκρυπτογράφησης.",
	"Play Video": "Αναπαραγωγή βίντεο",
	"Close": "Κλείσιμο",
	"Modal Window": "Aναδυόμενο παράθυρο",
	"This is a modal window": "Το παρών είναι ένα αναδυόμενο παράθυρο",
	"This modal can be closed by pressing the Escape key or activating the close button.": "Αυτό το παράθυρο μπορεί να εξαφανιστεί πατώντας το πλήκτρο Escape ή πατώντας το κουμπί κλεισίματος.",
	", opens captions settings dialog": ", εμφανίζει τις ρυθμίσεις για τις λεζάντες",
	", opens subtitles settings dialog": ", εμφανίζει τις ρυθμίσεις για τους υπότιτλους",
	", opens descriptions settings dialog": ", εμφανίζει τις ρυθμίσεις για τις περιγραφές",
	", selected": ", επιλεγμένο"
};

/***/ }),

/***/ 186:
/***/ (function(module, exports) {

module.exports = {
	"Play": "Play",
	"Pause": "Pause",
	"Current Time": "Current Time",
	"Duration Time": "Duration Time",
	"Remaining Time": "Remaining Time",
	"Stream Type": "Stream Type",
	"LIVE": "LIVE",
	"Loaded": "Loaded",
	"Progress": "Progress",
	"Fullscreen": "Fullscreen",
	"Non-Fullscreen": "Non-Fullscreen",
	"Mute": "Mute",
	"Unmute": "Unmute",
	"Playback Rate": "Playback Rate",
	"Subtitles": "Subtitles",
	"subtitles off": "subtitles off",
	"Captions": "Captions",
	"captions off": "captions off",
	"Chapters": "Chapters",
	"Close Modal Dialog": "Close Modal Dialog",
	"Descriptions": "Descriptions",
	"descriptions off": "descriptions off",
	"Audio Track": "Audio Track",
	"You aborted the media playback": "You aborted the media playback",
	"A network error caused the media download to fail part-way.": "A network error caused the media download to fail part-way.",
	"The media could not be loaded, either because the server or network failed or because the format is not supported.": "The media could not be loaded, either because the server or network failed or because the format is not supported.",
	"The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "The media playback was aborted due to a corruption problem or because the media used features your browser did not support.",
	"No compatible source was found for this media.": "No compatible source was found for this media.",
	"The media is encrypted and we do not have the keys to decrypt it.": "The media is encrypted and we do not have the keys to decrypt it.",
	"Play Video": "Play Video",
	"Close": "Close",
	"Modal Window": "Modal Window",
	"This is a modal window": "This is a modal window",
	"This modal can be closed by pressing the Escape key or activating the close button.": "This modal can be closed by pressing the Escape key or activating the close button.",
	", opens captions settings dialog": ", opens captions settings dialog",
	", opens subtitles settings dialog": ", opens subtitles settings dialog",
	", opens descriptions settings dialog": ", opens descriptions settings dialog",
	", selected": ", selected"
};

/***/ }),

/***/ 187:
/***/ (function(module, exports) {

module.exports = {
	"Play": "Reproducción",
	"Pause": "Pausa",
	"Current Time": "Tiempo reproducido",
	"Duration Time": "Duración total",
	"Remaining Time": "Tiempo restante",
	"Stream Type": "Tipo de secuencia",
	"LIVE": "DIRECTO",
	"Loaded": "Cargado",
	"Progress": "Progreso",
	"Fullscreen": "Pantalla completa",
	"Non-Fullscreen": "Pantalla no completa",
	"Mute": "Silenciar",
	"Unmute": "No silenciado",
	"Playback Rate": "Velocidad de reproducción",
	"Subtitles": "Subtítulos",
	"subtitles off": "Subtítulos desactivados",
	"Captions": "Subtítulos especiales",
	"captions off": "Subtítulos especiales desactivados",
	"Chapters": "Capítulos",
	"You aborted the media playback": "Ha interrumpido la reproducción del vídeo.",
	"A network error caused the media download to fail part-way.": "Un error de red ha interrumpido la descarga del vídeo.",
	"The media could not be loaded, either because the server or network failed or because the format is not supported.": "No se ha podido cargar el vídeo debido a un fallo de red o del servidor o porque el formato es incompatible.",
	"The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "La reproducción de vídeo se ha interrumpido por un problema de corrupción de datos o porque el vídeo precisa funciones que su navegador no ofrece.",
	"No compatible source was found for this media.": "No se ha encontrado ninguna fuente compatible con este vídeo."
};

/***/ }),

/***/ 188:
/***/ (function(module, exports) {

module.exports = {
	"Play": "پخش",
	"Pause": "وقفه",
	"Current Time": "زمان کنونی",
	"Duration Time": "مدت زمان",
	"Remaining Time": "زمان باقیمانده",
	"Stream Type": "نوع استریم",
	"LIVE": "زنده",
	"Loaded": "فراخوانی شده",
	"Progress": "پیشرفت",
	"Fullscreen": "تمام صفحه",
	"Non-Fullscreen": "نمایش عادی",
	"Mute": "بی صدا",
	"Unmute": "بهمراه صدا",
	"Playback Rate": "سرعت پخش",
	"Subtitles": "زیرنویس",
	"subtitles off": "بدون زیرنویس",
	"Captions": "عنوان",
	"captions off": "بدون عنوان",
	"Chapters": "فصل",
	"You aborted the media playback": "شما پخش را متوقف کردید.",
	"A network error caused the media download to fail part-way.": "مشکل در دریافت ویدئو ...",
	"The media could not be loaded, either because the server or network failed or because the format is not supported.": "فرمت پشتیبانی نمیشود یا خطایی روی داده است.",
	"The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "مشکل در دریافت ویدئو ...",
	"No compatible source was found for this media.": "هیچ ورودی ای برای این رسانه شناسایی نشد."
};

/***/ }),

/***/ 189:
/***/ (function(module, exports) {

module.exports = {
	"Play": "Toisto",
	"Pause": "Tauko",
	"Current Time": "Tämänhetkinen aika",
	"Duration Time": "Kokonaisaika",
	"Remaining Time": "Jäljellä oleva aika",
	"Stream Type": "Lähetystyyppi",
	"LIVE": "LIVE",
	"Loaded": "Ladattu",
	"Progress": "Edistyminen",
	"Fullscreen": "Koko näyttö",
	"Non-Fullscreen": "Koko näyttö pois",
	"Mute": "Ääni pois",
	"Unmute": "Ääni päällä",
	"Playback Rate": "Toistonopeus",
	"Subtitles": "Tekstitys",
	"subtitles off": "Tekstitys pois",
	"Captions": "Tekstitys",
	"captions off": "Tekstitys pois",
	"Chapters": "Kappaleet",
	"You aborted the media playback": "Olet keskeyttänyt videotoiston.",
	"A network error caused the media download to fail part-way.": "Verkkovirhe keskeytti videon latauksen.",
	"The media could not be loaded, either because the server or network failed or because the format is not supported.": "Videon lataus ei onnistunut joko palvelin- tai verkkovirheestä tai väärästä formaatista johtuen.",
	"The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "Videon toisto keskeytyi, koska media on vaurioitunut tai käyttää käyttää toimintoja, joita selaimesi ei tue.",
	"No compatible source was found for this media.": "Tälle videolle ei löytynyt yhteensopivaa lähdettä."
};

/***/ }),

/***/ 190:
/***/ (function(module, exports) {

module.exports = {
	"Play": "Lecture",
	"Pause": "Pause",
	"Current Time": "Temps actuel",
	"Duration Time": "Durée",
	"Remaining Time": "Temps restant",
	"Stream Type": "Type de flux",
	"LIVE": "EN DIRECT",
	"Loaded": "Chargé",
	"Progress": "Progression",
	"Fullscreen": "Plein écran",
	"Non-Fullscreen": "Fenêtré",
	"Mute": "Sourdine",
	"Unmute": "Son activé",
	"Playback Rate": "Vitesse de lecture",
	"Subtitles": "Sous-titres",
	"subtitles off": "Sous-titres désactivés",
	"Captions": "Sous-titres transcrits",
	"captions off": "Sous-titres transcrits désactivés",
	"Chapters": "Chapitres",
	"Close Modal Dialog": "Fermer la boîte de dialogue modale",
	"Descriptions": "Descriptions",
	"descriptions off": "descriptions désactivées",
	"Audio Track": "Piste audio",
	"You aborted the media playback": "Vous avez interrompu la lecture de la vidéo.",
	"A network error caused the media download to fail part-way.": "Une erreur de réseau a interrompu le téléchargement de la vidéo.",
	"The media could not be loaded, either because the server or network failed or because the format is not supported.": "Cette vidéo n'a pas pu être chargée, soit parce que le serveur ou le réseau a échoué ou parce que le format n'est pas reconnu.",
	"The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "La lecture de la vidéo a été interrompue à cause d'un problème de corruption ou parce que la vidéo utilise des fonctionnalités non prises en charge par votre navigateur.",
	"No compatible source was found for this media.": "Aucune source compatible n'a été trouvée pour cette vidéo.",
	"The media is encrypted and we do not have the keys to decrypt it.": "Le média est chiffré et nous n'avons pas les clés pour le déchiffrer.",
	"Play Video": "Lire la vidéo",
	"Close": "Fermer",
	"Modal Window": "Fenêtre modale",
	"This is a modal window": "Ceci est une fenêtre modale",
	"This modal can be closed by pressing the Escape key or activating the close button.": "Ce modal peut être fermé en appuyant sur la touche Échap ou activer le bouton de fermeture.",
	", opens captions settings dialog": ", ouvrir les paramètres des sous-titres transcrits",
	", opens subtitles settings dialog": ", ouvrir les paramètres des sous-titres",
	", opens descriptions settings dialog": ", ouvrir les paramètres des descriptions",
	", selected": ", sélectionné"
};

/***/ }),

/***/ 191:
/***/ (function(module, exports) {

module.exports = {
	"Play": "Pusti",
	"Pause": "Pauza",
	"Current Time": "Trenutno vrijeme",
	"Duration Time": "Vrijeme trajanja",
	"Remaining Time": "Preostalo vrijeme",
	"Stream Type": "Način strimovanja",
	"LIVE": "UŽIVO",
	"Loaded": "Učitan",
	"Progress": "Progres",
	"Fullscreen": "Puni ekran",
	"Non-Fullscreen": "Mali ekran",
	"Mute": "Prigušen",
	"Unmute": "Ne-prigušen",
	"Playback Rate": "Stopa reprodukcije",
	"Subtitles": "Podnaslov",
	"subtitles off": "Podnaslov deaktiviran",
	"Captions": "Titlovi",
	"captions off": "Titlovi deaktivirani",
	"Chapters": "Poglavlja",
	"You aborted the media playback": "Isključili ste reprodukciju videa.",
	"A network error caused the media download to fail part-way.": "Video se prestao preuzimati zbog greške na mreži.",
	"The media could not be loaded, either because the server or network failed or because the format is not supported.": "Video se ne može reproducirati zbog servera, greške u mreži ili je format ne podržan.",
	"The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "Reprodukcija videa je zaustavljenja zbog greške u formatu ili zbog verzije vašeg pretraživača.",
	"No compatible source was found for this media.": "Nije nađen nijedan kompatibilan izvor ovog videa."
};

/***/ }),

/***/ 192:
/***/ (function(module, exports) {

module.exports = {
	"Play": "Lejátszás",
	"Pause": "Szünet",
	"Current Time": "Aktuális időpont",
	"Duration Time": "Hossz",
	"Remaining Time": "Hátralévő idő",
	"Stream Type": "Adatfolyam típusa",
	"LIVE": "ÉLŐ",
	"Loaded": "Betöltve",
	"Progress": "Állapot",
	"Fullscreen": "Teljes képernyő",
	"Non-Fullscreen": "Normál méret",
	"Mute": "Némítás",
	"Unmute": "Némítás kikapcsolva",
	"Playback Rate": "Lejátszási sebesség",
	"Subtitles": "Feliratok",
	"subtitles off": "Feliratok kikapcsolva",
	"Captions": "Magyarázó szöveg",
	"captions off": "Magyarázó szöveg kikapcsolva",
	"Chapters": "Fejezetek",
	"You aborted the media playback": "Leállította a lejátszást",
	"A network error caused the media download to fail part-way.": "Hálózati hiba miatt a videó részlegesen töltődött le.",
	"The media could not be loaded, either because the server or network failed or because the format is not supported.": "A videó nem tölthető be hálózati vagy kiszolgálói hiba miatt, vagy a formátuma nem támogatott.",
	"The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "A lejátszás adatsérülés miatt leállt, vagy a videó egyes tulajdonságait a böngészője nem támogatja.",
	"No compatible source was found for this media.": "Nincs kompatibilis forrás ehhez a videóhoz."
};

/***/ }),

/***/ 193:
/***/ (function(module, exports) {

module.exports = {
	"Play": "Play",
	"Pause": "Pausa",
	"Current Time": "Orario attuale",
	"Duration Time": "Durata",
	"Remaining Time": "Tempo rimanente",
	"Stream Type": "Tipo del Streaming",
	"LIVE": "LIVE",
	"Loaded": "Caricato",
	"Progress": "Stato",
	"Fullscreen": "Schermo intero",
	"Non-Fullscreen": "Chiudi schermo intero",
	"Mute": "Muto",
	"Unmute": "Audio",
	"Playback Rate": "Tasso di riproduzione",
	"Subtitles": "Sottotitoli",
	"subtitles off": "Senza sottotitoli",
	"Captions": "Sottotitoli non udenti",
	"captions off": "Senza sottotitoli non udenti",
	"Chapters": "Capitolo",
	"You aborted the media playback": "La riproduzione del filmato è stata interrotta.",
	"A network error caused the media download to fail part-way.": "Il download del filmato è stato interrotto a causa di un problema rete.",
	"The media could not be loaded, either because the server or network failed or because the format is not supported.": "Il filmato non può essere caricato a causa di un errore nel server o nella rete o perché il formato non viene supportato.",
	"The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "La riproduzione del filmato è stata interrotta a causa di un file danneggiato o per l’utilizzo di impostazioni non supportate dal browser.",
	"No compatible source was found for this media.": "Non ci sono fonti compatibili per questo filmato."
};

/***/ }),

/***/ 194:
/***/ (function(module, exports) {

module.exports = {
	"Play": "再生",
	"Pause": "一時停止",
	"Current Time": "現在の時間",
	"Duration Time": "長さ",
	"Remaining Time": "残りの時間",
	"Stream Type": "ストリームの種類",
	"LIVE": "ライブ",
	"Loaded": "ロード済み",
	"Progress": "進行状況",
	"Fullscreen": "フルスクリーン",
	"Non-Fullscreen": "フルスクリーン以外",
	"Mute": "ミュート",
	"Unmute": "ミュート解除",
	"Playback Rate": "再生レート",
	"Subtitles": "サブタイトル",
	"subtitles off": "サブタイトル オフ",
	"Captions": "キャプション",
	"captions off": "キャプション オフ",
	"Chapters": "チャプター",
	"You aborted the media playback": "動画再生を中止しました",
	"A network error caused the media download to fail part-way.": "ネットワーク エラーにより動画のダウンロードが途中で失敗しました",
	"The media could not be loaded, either because the server or network failed or because the format is not supported.": "サーバーまたはネットワークのエラー、またはフォーマットがサポートされていないため、動画をロードできませんでした",
	"The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "破損の問題、またはお使いのブラウザがサポートしていない機能が動画に使用されていたため、動画の再生が中止されました",
	"No compatible source was found for this media.": "この動画に対して互換性のあるソースが見つかりませんでした"
};

/***/ }),

/***/ 195:
/***/ (function(module, exports) {

module.exports = {
	"Play": "재생",
	"Pause": "일시중지",
	"Current Time": "현재 시간",
	"Duration Time": "지정 기간",
	"Remaining Time": "남은 시간",
	"Stream Type": "스트리밍 유형",
	"LIVE": "라이브",
	"Loaded": "로드됨",
	"Progress": "진행",
	"Fullscreen": "전체 화면",
	"Non-Fullscreen": "전체 화면 해제",
	"Mute": "음소거",
	"Unmute": "음소거 해제",
	"Playback Rate": "재생 비율",
	"Subtitles": "서브타이틀",
	"subtitles off": "서브타이틀 끄기",
	"Captions": "자막",
	"captions off": "자막 끄기",
	"Chapters": "챕터",
	"You aborted the media playback": "비디오 재생을 취소했습니다.",
	"A network error caused the media download to fail part-way.": "네트워크 오류로 인하여 비디오 일부를 다운로드하지 못 했습니다.",
	"The media could not be loaded, either because the server or network failed or because the format is not supported.": "비디오를 로드할 수 없습니다. 서버 혹은 네트워크 오류 때문이거나 지원되지 않는 형식 때문일 수 있습니다.",
	"The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "비디오 재생이 취소됐습니다. 비디오가 손상되었거나 비디오가 사용하는 기능을 브라우저에서 지원하지 않는 것 같습니다.",
	"No compatible source was found for this media.": "비디오에 호환되지 않는 소스가 있습니다."
};

/***/ }),

/***/ 196:
/***/ (function(module, exports) {

module.exports = {
	"Play": "Spill",
	"Pause": "Pause",
	"Current Time": "Aktuell tid",
	"Duration Time": "Varighet",
	"Remaining Time": "Gjenstående tid",
	"Stream Type": "Type strøm",
	"LIVE": "DIREKTE",
	"Loaded": "Lastet inn",
	"Progress": "Status",
	"Fullscreen": "Fullskjerm",
	"Non-Fullscreen": "Lukk fullskjerm",
	"Mute": "Lyd av",
	"Unmute": "Lyd på",
	"Playback Rate": "Avspillingsrate",
	"Subtitles": "Undertekst på",
	"subtitles off": "Undertekst av",
	"Captions": "Undertekst for hørselshemmede på",
	"captions off": "Undertekst for hørselshemmede av",
	"Chapters": "Kapitler",
	"You aborted the media playback": "Du avbrøt avspillingen.",
	"A network error caused the media download to fail part-way.": "En nettverksfeil avbrøt nedlasting av videoen.",
	"The media could not be loaded, either because the server or network failed or because the format is not supported.": "Videoen kunne ikke lastes ned, på grunn av nettverksfeil eller serverfeil, eller fordi formatet ikke er støttet.",
	"The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "Videoavspillingen ble avbrudt på grunn av ødelagte data eller fordi videoen ville gjøre noe som nettleseren din ikke har støtte for.",
	"No compatible source was found for this media.": "Fant ikke en kompatibel kilde for dette mediainnholdet."
};

/***/ }),

/***/ 197:
/***/ (function(module, exports) {

module.exports = {
	"Play": "Afspelen",
	"Pause": "Pauze",
	"Current Time": "Huidige tijd",
	"Duration Time": "Looptijd",
	"Remaining Time": "Resterende tijd",
	"Stream Type": "Streamtype",
	"LIVE": "LIVE",
	"Loaded": "Geladen",
	"Progress": "Status",
	"Fullscreen": "Volledig scherm",
	"Non-Fullscreen": "Geen volledig scherm",
	"Mute": "Geluid uit",
	"Unmute": "Geluid aan",
	"Playback Rate": "Weergavesnelheid",
	"Subtitles": "Ondertiteling",
	"subtitles off": "ondertiteling uit",
	"Captions": "Bijschriften",
	"captions off": "bijschriften uit",
	"Chapters": "Hoofdstukken",
	"Descriptions": "Beschrijvingen",
	"descriptions off": "beschrijvingen off",
	"You aborted the media playback": "U hebt de mediaweergave afgebroken.",
	"A network error caused the media download to fail part-way.": "De mediadownload is mislukt door een netwerkfout.",
	"The media could not be loaded, either because the server or network failed or because the format is not supported.": "De media kon niet worden geladen, vanwege een server- of netwerkfout of doordat het formaat niet wordt ondersteund.",
	"The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "De mediaweergave is afgebroken vanwege beschadigde data of het mediabestand gebruikt functies die niet door uw browser worden ondersteund.",
	"No compatible source was found for this media.": "Voor deze media is geen ondersteunde bron gevonden.",
	"Play Video": "Video Afspelen",
	"Close": "Sluiten",
	"Modal Window": "Modal Venster",
	"This is a modal window": "Dit is een modaal venster",
	"This modal can be closed by pressing the Escape key or activating the close button.": "Dit modaal venster kan gesloten worden door op Escape te drukken of de 'sluiten' knop te activeren.",
	", opens captions settings dialog": ", opent bijschriften instellingen venster",
	", opens subtitles settings dialog": ", opent ondertiteling instellingen venster",
	", opens descriptions settings dialog": ", opent beschrijvingen instellingen venster",
	", selected": ", selected"
};

/***/ }),

/***/ 198:
/***/ (function(module, exports) {

module.exports = {
	"Play": "Spel",
	"Pause": "Pause",
	"Current Time": "Aktuell tid",
	"Duration Time": "Varigheit",
	"Remaining Time": "Tid attende",
	"Stream Type": "Type straum",
	"LIVE": "DIREKTE",
	"Loaded": "Lasta inn",
	"Progress": "Status",
	"Fullscreen": "Fullskjerm",
	"Non-Fullscreen": "Stenga fullskjerm",
	"Mute": "Ljod av",
	"Unmute": "Ljod på",
	"Playback Rate": "Avspelingsrate",
	"Subtitles": "Teksting på",
	"subtitles off": "Teksting av",
	"Captions": "Teksting for høyrselshemma på",
	"captions off": "Teksting for høyrselshemma av",
	"Chapters": "Kapitel",
	"You aborted the media playback": "Du avbraut avspelinga.",
	"A network error caused the media download to fail part-way.": "Ein nettverksfeil avbraut nedlasting av videoen.",
	"The media could not be loaded, either because the server or network failed or because the format is not supported.": "Videoen kunne ikkje lastas ned, på grunn av ein nettverksfeil eller serverfeil, eller av di formatet ikkje er stoda.",
	"The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "Videoavspelinga blei broten på grunn av øydelagde data eller av di videoen ville gjera noe som nettlesaren din ikkje stodar.",
	"No compatible source was found for this media.": "Fant ikke en kompatibel kilde for dette mediainnholdet."
};

/***/ }),

/***/ 199:
/***/ (function(module, exports) {

module.exports = {
	"Play": "Odtwarzaj",
	"Pause": "Pauza",
	"Current Time": "Aktualny czas",
	"Duration Time": "Czas trwania",
	"Remaining Time": "Pozostały czas",
	"Stream Type": "Typ strumienia",
	"LIVE": "NA ŻYWO",
	"Loaded": "Załadowany",
	"Progress": "Status",
	"Fullscreen": "Pełny ekran",
	"Non-Fullscreen": "Pełny ekran niedostępny",
	"Mute": "Wyłącz dźwięk",
	"Unmute": "Włącz dźwięk",
	"Playback Rate": "Szybkość odtwarzania",
	"Subtitles": "Napisy",
	"subtitles off": "Napisy wyłączone",
	"Captions": "Transkrypcja",
	"captions off": "Transkrypcja wyłączona",
	"Chapters": "Rozdziały",
	"You aborted the media playback": "Odtwarzanie zostało przerwane",
	"A network error caused the media download to fail part-way.": "Problemy z siecią spowodowały błąd przy pobieraniu materiału wideo.",
	"The media could not be loaded, either because the server or network failed or because the format is not supported.": "Materiał wideo nie może być załadowany, ponieważ wystąpił problem z siecią lub format nie jest obsługiwany",
	"The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "Odtwarzanie materiału wideo zostało przerwane z powodu uszkodzonego pliku wideo lub z powodu błędu funkcji, które nie są wspierane przez przeglądarkę.",
	"No compatible source was found for this media.": "Dla tego materiału wideo nie znaleziono kompatybilnego źródła.",
	"Play video": "Odtwarzaj wideo",
	"Close": "Zamknij",
	"Modal Window": "Okno Modala",
	"This is a modal window": "To jest okno modala",
	"This modal can be closed by pressing the Escape key or activating the close button.": "Ten modal możesz zamknąć naciskając przycisk Escape albo wybierając przycisk Zamknij.",
	", opens captions settings dialog": ", otwiera okno dialogowe ustawień transkrypcji",
	", opens subtitles settings dialog": ", otwiera okno dialogowe napisów",
	", selected": ", zaznaczone"
};

/***/ }),

/***/ 200:
/***/ (function(module, exports) {

module.exports = {
	"Play": "Tocar",
	"Pause": "Pausar",
	"Current Time": "Tempo",
	"Duration Time": "Duração",
	"Remaining Time": "Tempo Restante",
	"Stream Type": "Tipo de Stream",
	"LIVE": "AO VIVO",
	"Loaded": "Carregado",
	"Progress": "Progresso",
	"Fullscreen": "Tela Cheia",
	"Non-Fullscreen": "Tela Normal",
	"Mute": "Mudo",
	"Unmute": "Habilitar Som",
	"Playback Rate": "Velocidade",
	"Subtitles": "Legendas",
	"subtitles off": "Sem Legendas",
	"Captions": "Anotações",
	"captions off": "Sem Anotações",
	"Chapters": "Capítulos",
	"You aborted the media playback": "Você parou a execução do vídeo.",
	"A network error caused the media download to fail part-way.": "Um erro na rede fez o vídeo parar parcialmente.",
	"The media could not be loaded, either because the server or network failed or because the format is not supported.": "O vídeo não pode ser carregado, ou porque houve um problema com sua rede ou pelo formato do vídeo não ser suportado.",
	"The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "A execução foi interrompida por um problema com o vídeo ou por seu navegador não dar suporte ao seu formato.",
	"No compatible source was found for this media.": "Não foi encontrada fonte de vídeo compatível."
};

/***/ }),

/***/ 201:
/***/ (function(module, exports) {

module.exports = {
	"Play": "Воспроизвести",
	"Pause": "Приостановить",
	"Current Time": "Текущее время",
	"Duration Time": "Продолжительность",
	"Remaining Time": "Оставшееся время",
	"Stream Type": "Тип потока",
	"LIVE": "ОНЛАЙН",
	"Loaded": "Загрузка",
	"Progress": "Прогресс",
	"Fullscreen": "Полноэкранный режим",
	"Non-Fullscreen": "Неполноэкранный режим",
	"Mute": "Без звука",
	"Unmute": "Со звуком",
	"Playback Rate": "Скорость воспроизведения",
	"Subtitles": "Субтитры",
	"subtitles off": "Субтитры выкл.",
	"Captions": "Подписи",
	"captions off": "Подписи выкл.",
	"Chapters": "Главы",
	"You aborted the media playback": "Вы прервали воспроизведение видео",
	"A network error caused the media download to fail part-way.": "Ошибка сети вызвала сбой во время загрузки видео.",
	"The media could not be loaded, either because the server or network failed or because the format is not supported.": "Невозможно загрузить видео из-за сетевого или серверного сбоя либо формат не поддерживается.",
	"The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "Воспроизведение видео было приостановлено из-за повреждения либо в связи с тем, что видео использует функции, неподдерживаемые вашим браузером.",
	"No compatible source was found for this media.": "Совместимые источники для этого видео отсутствуют."
};

/***/ }),

/***/ 202:
/***/ (function(module, exports) {

module.exports = {
	"Play": "Pusti",
	"Pause": "Pauza",
	"Current Time": "Trenutno vrijeme",
	"Duration Time": "Vrijeme trajanja",
	"Remaining Time": "Preostalo vrijeme",
	"Stream Type": "Način strimovanja",
	"LIVE": "UŽIVO",
	"Loaded": "Učitan",
	"Progress": "Progres",
	"Fullscreen": "Puni ekran",
	"Non-Fullscreen": "Mali ekran",
	"Mute": "Prigušen",
	"Unmute": "Ne-prigušen",
	"Playback Rate": "Stopa reprodukcije",
	"Subtitles": "Podnaslov",
	"subtitles off": "Podnaslov deaktiviran",
	"Captions": "Titlovi",
	"captions off": "Titlovi deaktivirani",
	"Chapters": "Poglavlja",
	"You aborted the media playback": "Isključili ste reprodukciju videa.",
	"A network error caused the media download to fail part-way.": "Video se prestao preuzimati zbog greške na mreži.",
	"The media could not be loaded, either because the server or network failed or because the format is not supported.": "Video se ne može reproducirati zbog servera, greške u mreži ili je format ne podržan.",
	"The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "Reprodukcija videa je zaustavljenja zbog greške u formatu ili zbog verzije vašeg pretraživača.",
	"No compatible source was found for this media.": "Nije nađen nijedan kompatibilan izvor ovog videa."
};

/***/ }),

/***/ 203:
/***/ (function(module, exports) {

module.exports = {
	"Play": "Spela",
	"Pause": "Pausa",
	"Current Time": "Aktuell tid",
	"Duration Time": "Total tid",
	"Remaining Time": "Återstående tid",
	"Stream Type": "Strömningstyp",
	"LIVE": "LIVE",
	"Loaded": "Laddad",
	"Progress": "Förlopp",
	"Fullscreen": "Fullskärm",
	"Non-Fullscreen": "Ej fullskärm",
	"Mute": "Ljud av",
	"Unmute": "Ljud på",
	"Playback Rate": "Uppspelningshastighet",
	"Subtitles": "Text på",
	"subtitles off": "Text av",
	"Captions": "Text på",
	"captions off": "Text av",
	"Chapters": "Kapitel",
	"You aborted the media playback": "Du har avbrutit videouppspelningen.",
	"A network error caused the media download to fail part-way.": "Ett nätverksfel gjorde att nedladdningen av videon avbröts.",
	"The media could not be loaded, either because the server or network failed or because the format is not supported.": "Det gick inte att ladda videon, antingen på grund av ett server- eller nätverksfel, eller för att formatet inte stöds.",
	"The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "Uppspelningen avbröts på grund av att videon är skadad, eller också för att videon använder funktioner som din webbläsare inte stöder.",
	"No compatible source was found for this media.": "Det gick inte att hitta någon kompatibel källa för den här videon."
};

/***/ }),

/***/ 204:
/***/ (function(module, exports) {

module.exports = {
	"Play": "Oynat",
	"Pause": "Duraklat",
	"Current Time": "Süre",
	"Duration Time": "Toplam Süre",
	"Remaining Time": "Kalan Süre",
	"Stream Type": "Yayın Tipi",
	"LIVE": "CANLI",
	"Loaded": "Yüklendi",
	"Progress": "Yükleniyor",
	"Fullscreen": "Tam Ekran",
	"Non-Fullscreen": "Küçük Ekran",
	"Mute": "Ses Kapa",
	"Unmute": "Ses Aç",
	"Playback Rate": "Oynatma Hızı",
	"Subtitles": "Altyazı",
	"subtitles off": "Altyazı Kapalı",
	"Captions": "Ek Açıklamalar",
	"captions off": "Ek Açıklamalar Kapalı",
	"Chapters": "Bölümler",
	"You aborted the media playback": "Video oynatmayı iptal ettiniz",
	"A network error caused the media download to fail part-way.": "Video indirilirken bağlantı sorunu oluştu.",
	"The media could not be loaded, either because the server or network failed or because the format is not supported.": "Video oynatılamadı, ağ ya da sunucu hatası veya belirtilen format desteklenmiyor.",
	"The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "Tarayıcınız desteklemediği için videoda hata oluştu.",
	"No compatible source was found for this media.": "Video için kaynak bulunamadı.",
	"Play Video": "Videoyu Oynat",
	"Close": "Kapat",
	"Modal Window": "Modal Penceresi",
	"This is a modal window": "Bu bir modal penceresidir",
	"This modal can be closed by pressing the Escape key or activating the close button.": "Bu modal ESC tuşuna basarak ya da kapata tıklanarak kapatılabilir.",
	", opens captions settings dialog": ", ek açıklama ayarları menüsünü açar",
	", opens subtitles settings dialog": ", altyazı ayarları menüsünü açar",
	", selected": ", seçildi"
};

/***/ }),

/***/ 205:
/***/ (function(module, exports) {

module.exports = {
	"Play": "Відтворити",
	"Pause": "Призупинити",
	"Current Time": "Поточний час",
	"Duration Time": "Тривалість",
	"Remaining Time": "Час, що залишився",
	"Stream Type": "Тип потоку",
	"LIVE": "НАЖИВО",
	"Loaded": "Завантаження",
	"Progress": "Прогрес",
	"Fullscreen": "Повноекранний режим",
	"Non-Fullscreen": "Неповноекранний режим",
	"Mute": "Без звуку",
	"Unmute": "Зі звуком",
	"Playback Rate": "Швидкість відтворення",
	"Subtitles": "Субтитри",
	"subtitles off": "Без субтитрів",
	"Captions": "Підписи",
	"captions off": "Без підписів",
	"Chapters": "Розділи",
	"You aborted the media playback": "Ви припинили відтворення відео",
	"A network error caused the media download to fail part-way.": "Помилка мережі викликала збій під час завантаження відео.",
	"The media could not be loaded, either because the server or network failed or because the format is not supported.": "Неможливо завантажити відео через мережевий чи серверний збій або формат не підтримується.",
	"The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "Відтворення відео було припинено через пошкодження або у зв'язку з тим, що відео використовує функції, які не підтримуються вашим браузером.",
	"No compatible source was found for this media.": "Сумісні джерела для цього відео відсутні."
};

/***/ }),

/***/ 206:
/***/ (function(module, exports) {

module.exports = {
	"Play": "Phát",
	"Pause": "Tạm dừng",
	"Current Time": "Thời gian hiện tại",
	"Duration Time": "Độ dài",
	"Remaining Time": "Thời gian còn lại",
	"Stream Type": "Kiểu Stream",
	"LIVE": "TRỰC TIẾP",
	"Loaded": "Đã tải",
	"Progress": "Tiến trình",
	"Fullscreen": "Toàn màn hình",
	"Non-Fullscreen": "Thoát toàn màn hình",
	"Mute": "Tắt tiếng",
	"Unmute": "Bật âm thanh",
	"Playback Rate": "Tốc độ phát",
	"Subtitles": "Phụ đề",
	"subtitles off": "Tắt phụ đề",
	"Captions": "Chú thích",
	"captions off": "Tắt chú thích",
	"Chapters": "Chương",
	"You aborted the media playback": "Bạn đã hủy việc phát media.",
	"A network error caused the media download to fail part-way.": "Một lỗi mạng dẫn đến việc tải media bị lỗi.",
	"The media could not be loaded, either because the server or network failed or because the format is not supported.": "Video không tải được, mạng hay server có lỗi hoặc định dạng không được hỗ trợ.",
	"The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "Phát media đã bị hủy do một sai lỗi hoặc media sử dụng những tính năng trình duyệt không hỗ trợ.",
	"No compatible source was found for this media.": "Không có nguồn tương thích cho media này."
};

/***/ }),

/***/ 207:
/***/ (function(module, exports) {

module.exports = {
	"Play": "播放",
	"Pause": "暂停",
	"Current Time": "当前时间",
	"Duration Time": "时长",
	"Remaining Time": "剩余时间",
	"Stream Type": "媒体流类型",
	"LIVE": "直播",
	"Loaded": "加载完毕",
	"Progress": "进度",
	"Fullscreen": "全屏",
	"Non-Fullscreen": "退出全屏",
	"Mute": "静音",
	"Unmute": "取消静音",
	"Playback Rate": "播放码率",
	"Subtitles": "字幕",
	"subtitles off": "字幕关闭",
	"Captions": "内嵌字幕",
	"captions off": "内嵌字幕关闭",
	"Chapters": "节目段落",
	"You aborted the media playback": "视频播放被终止",
	"A network error caused the media download to fail part-way.": "网络错误导致视频下载中途失败。",
	"The media could not be loaded, either because the server or network failed or because the format is not supported.": "视频因格式不支持或者服务器或网络的问题无法加载。",
	"The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "由于视频文件损坏或是该视频使用了你的浏览器不支持的功能，播放终止。",
	"No compatible source was found for this media.": "无法找到此视频兼容的源。",
	"The media is encrypted and we do not have the keys to decrypt it.": "视频已加密，无法解密。"
};

/***/ }),

/***/ 208:
/***/ (function(module, exports) {

module.exports = {
	"Play": "播放",
	"Pause": "暫停",
	"Current Time": "目前時間",
	"Duration Time": "總共時間",
	"Remaining Time": "剩餘時間",
	"Stream Type": "串流類型",
	"LIVE": "直播",
	"Loaded": "載入完畢",
	"Progress": "進度",
	"Fullscreen": "全螢幕",
	"Non-Fullscreen": "退出全螢幕",
	"Mute": "靜音",
	"Unmute": "取消靜音",
	"Playback Rate": " 播放速率",
	"Subtitles": "字幕",
	"subtitles off": "關閉字幕",
	"Captions": "內嵌字幕",
	"captions off": "關閉內嵌字幕",
	"Chapters": "章節",
	"You aborted the media playback": "影片播放已終止",
	"A network error caused the media download to fail part-way.": "網路錯誤導致影片下載失敗。",
	"The media could not be loaded, either because the server or network failed or because the format is not supported.": "影片因格式不支援或者伺服器或網路的問題無法載入。",
	"The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "由於影片檔案損毀或是該影片使用了您的瀏覽器不支援的功能，播放終止。",
	"No compatible source was found for this media.": "無法找到相容此影片的來源。",
	"The media is encrypted and we do not have the keys to decrypt it.": "影片已加密，無法解密。"
};

/***/ }),

/***/ 269:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 75:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 92:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(177);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },

  routes: [{ //首页
    path: '/',
    name: 'index',
    component: function component(resolve) {
      __webpack_require__.e/* require */(8).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(289)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //轮播图详情
    path: '/carouselFigureDetail',
    name: 'carouselFigureDetail',
    component: function component(resolve) {
      __webpack_require__.e/* require */(66).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(272)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //注册
    path: '/register',
    name: 'register',
    component: function component(resolve) {
      __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(293)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //登录
    path: '/login',
    name: 'login',
    component: function component(resolve) {
      __webpack_require__.e/* require */(68).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(290)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { // 短信登录
    path: '/smsLogin',
    name: 'smsLogin',
    component: function component(resolve) {
      __webpack_require__.e/* require */(31).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(334)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  // 个人中心模块
  { //个人中心
    path: '/memberCenter',
    name: 'grzx',
    component: function component(resolve) {
      __webpack_require__.e/* require */(13).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(297)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //我的证书
    path: '/wdzs',
    name: 'wdzs',
    component: function component(resolve) {
      __webpack_require__.e/* require */(26).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(315)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //我的证书
    path: '/myZsDetail',
    name: 'myZsDetail',
    component: function component(resolve) {
      __webpack_require__.e/* require */(25).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(316)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //证书申领-个人证书
    path: '/applyCert',
    name: 'applyCert',
    component: function component(resolve) {
      __webpack_require__.e/* require */(40).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(310)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //证书申领-批量申领
    path: '/applyCertBatch',
    name: 'applyCertBatch',
    component: function component(resolve) {
      __webpack_require__.e/* require */(39).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(311)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //查看运单
    path: '/orderExpress',
    name: 'orderExpress',
    component: function component(resolve) {
      __webpack_require__.e/* require */(47).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(314)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //检查证书运单
    path: '/checkOrderExpress',
    name: 'checkOrderExpress',
    component: function component(resolve) {
      __webpack_require__.e/* require */(35).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(312)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //检查证书运单
    path: '/checkOrderExpressBatch',
    name: 'checkOrderExpressBatch',
    component: function component(resolve) {
      __webpack_require__.e/* require */(34).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(313)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //签到
    path: '/checkIn',
    name: 'checkIn',
    component: function component(resolve) {
      __webpack_require__.e/* require */(36).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(296)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //我的积分
    path: '/wdjf',
    name: 'wdjf',
    component: function component(resolve) {
      __webpack_require__.e/* require */(48).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(309)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //我的账户
    path: '/zhgl',
    name: 'zhgl',
    component: function component(resolve) {
      __webpack_require__.e/* require */(46).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(317)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //个人资料
    path: '/memberData',
    name: 'memberData',
    component: function component(resolve) {
      __webpack_require__.e/* require */(16).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(304)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //个人资料单项
    path: '/memberDataSingle',
    name: 'memberDataSingle',
    component: function component(resolve) {
      __webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(305)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  //  个人中心-证书查验模块
  { //证书查验
    path: '/zscy',
    name: 'zscy',
    component: function component(resolve) {
      __webpack_require__.e/* require */(9).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(349)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //证书列表
    path: '/zslb',
    name: 'zslb',
    component: function component(resolve) {
      __webpack_require__.e/* require */(14).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(348)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //证书详情
    path: '/zsdetail',
    name: 'zsdetail',
    component: function component(resolve) {
      __webpack_require__.e/* require */(23).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(350)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //证书图文预览
    path: '/zsscan',
    name: 'zsscan',
    component: function component(resolve) {
      __webpack_require__.e/* require */(74).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(351)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //学时证明列表
    path: '/xslb',
    name: 'xslb',
    component: function component(resolve) {
      __webpack_require__.e/* require */(15).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(345)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //学时证明详情
    path: '/xsdetail',
    name: 'xsdetail',
    component: function component(resolve) {
      __webpack_require__.e/* require */(24).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(346)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //学时证明图文预览
    path: '/xsscan',
    name: 'xsscan',
    component: function component(resolve) {
      __webpack_require__.e/* require */(75).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(347)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  // 课程学习模块
  { //我的培训班
    path: '/myClass',
    name: 'myClass',
    component: function component(resolve) {
      __webpack_require__.e/* require */(22).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(338)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //我的练习
    path: '/myMock',
    name: 'myMock',
    component: function component(resolve) {
      __webpack_require__.e/* require */(11).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(340)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //我的课程
    path: '/myCourse',
    name: 'myCourse',
    component: function component(resolve) {
      __webpack_require__.e/* require */(37).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(339)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //学历提升
    path: '/degree',
    name: 'degree',
    component: function component(resolve) {
      __webpack_require__.e/* require */(10).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(337)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //成人自考列表
    path: '/crzk',
    name: 'crzk',
    component: function component(resolve) {
      __webpack_require__.e/* require */(78).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(336)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //网络教育列表
    path: '/wljy',
    name: 'wljy',
    component: function component(resolve) {
      __webpack_require__.e/* require */(77).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(342)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  // {
  //   path:'/onStudy',                                  //在学课程
  //   name:'onStudy',
  //   component:function(resolve){
  //     require(["@/pages/study/onStudy"],resolve);
  //   }
  // },
  { //课程章节
    path: '/courseChapter',
    name: 'courseChapter',
    component: function component(resolve) {
      __webpack_require__.e/* require */(38).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(335)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //学时证明
    path: '/xsLook',
    name: 'xsLook',
    component: function component(resolve) {
      __webpack_require__.e/* require */(76).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(343)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //视频播放
    path: '/player',
    name: 'player',
    meta: { keepAlive: false },
    component: function component(resolve) {
      __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(341)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //试听
    path: '/tryPlayer',
    name: 'tryPlayer',
    component: function component(resolve) {
      __webpack_require__.e/* require */(73).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(331)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  // 报名选课模块
  { //选择班级
    path: '/chooseClass',
    name: 'chooseClass',
    component: function component(resolve) {
      __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(319)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //班级详情
    path: '/classDetail',
    name: 'classDetail',
    component: function component(resolve) {
      __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(321)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //查看评价
    path: '/judgeScan',
    name: 'judgeScan',
    component: function component(resolve) {
      __webpack_require__.e/* require */(32).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(325)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //班级详情
    path: '/courseDetail',
    name: 'courseDetail',
    component: function component(resolve) {
      __webpack_require__.e/* require */(17).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(322)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //确认报名班级
    path: '/ensureClass',
    name: 'ensureClass',
    component: function component(resolve) {
      __webpack_require__.e/* require */(45).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(323)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //选择学习课程
    path: '/chooseCourse',
    name: 'chooseCourse',
    component: function component(resolve) {
      __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(320)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //购物车
    path: '/shoppingCart',
    name: 'shoppingCart',
    component: function component(resolve) {
      __webpack_require__.e/* require */(5).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(326)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //购物车
    path: '/checkOrder',
    name: 'checkOrder',
    component: function component(resolve) {
      __webpack_require__.e/* require */(33).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(318)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //选择查看购物车班级里课程
    path: '/shoppingCartCourse',
    name: 'shoppingCartCourse',
    component: function component(resolve) {
      __webpack_require__.e/* require */(44).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(330)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  //    	{	//微信订单生成
  // path:'/myOrder/pay',
  // name:'wxpay',
  // component:function(resolve){
  //        		require(["@/pages/signIn/myOrder"],resolve);
  //      	},
  //    	},
  { //支付
    path: '/myOrder/pay',
    name: 'wxpay',
    component: function component(resolve) {
      __webpack_require__.e/* require */(20).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(327)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //运单支付
    path: '/myExpress/pay',
    name: 'expressPay',
    component: function component(resolve) {
      __webpack_require__.e/* require */(21).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(324)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //支付结果返回
    path: '/payResult',
    name: 'payResult',
    component: function component(resolve) {
      __webpack_require__.e/* require */(71).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(329)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //支付结果返回
    path: '/payExpressResult',
    name: 'payExpressResult',
    component: function component(resolve) {
      __webpack_require__.e/* require */(72).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(328)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //银联支付结果返回
    path: '/unionPayResult',
    name: 'unionPayResult',
    component: function component(resolve) {
      __webpack_require__.e/* require */(70).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(332)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //微信支付结果返回
    path: '/wxPayResult',
    name: 'wxPayResult',
    component: function component(resolve) {
      __webpack_require__.e/* require */(69).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(333)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  // 个人中心-订单模块
  { //订单列表
    path: '/orderList',
    name: 'orderList',
    meta: { keepAlive: false },
    component: function component(resolve) {
      __webpack_require__.e/* require */(49).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(308)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //订单详情
    path: '/orderDetail',
    name: 'orderDetail',
    component: function component(resolve) {
      __webpack_require__.e/* require */(50).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(307)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //取消订单跳转页面用
    path: '/orderClear',
    name: 'orderClear',
    component: function component(resolve) {
      __webpack_require__.e/* require */(79).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(306)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  // 个人中心-发票模块
  { //发票列表
    path: '/invoiceList',
    name: 'invoiceList',
    component: function component(resolve) {
      __webpack_require__.e/* require */(51).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(302)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //发票列表
    path: '/invoiceList_',
    name: 'invoiceList_',
    component: function component(resolve) {
      __webpack_require__.e/* require */(41).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(303)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //发票详情
    path: '/invoiceDetail',
    name: 'invoiceDetail',
    component: function component(resolve) {
      __webpack_require__.e/* require */(53).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(300)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //发票详情-电子发票
    path: '/invoiceDetailEle',
    name: 'invoiceDetailEle',
    component: function component(resolve) {
      __webpack_require__.e/* require */(52).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(301)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //申请发票列表
    path: '/aplayInvoiceList',
    name: 'aplayInvoiceList',
    component: function component(resolve) {
      __webpack_require__.e/* require */(54).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(299)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //申请发票
    path: '/aplayInvoice',
    name: 'aplayInvoice',
    component: function component(resolve) {
      __webpack_require__.e/* require */(55).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(298)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  // 个人中心  寄送地址模块
  { //寄送地址
    path: '/jsdz',
    name: 'jsdz',
    component: function component(resolve) {
      __webpack_require__.e/* require */(30).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(294)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //新增寄送地址
    path: '/xzjsdz',
    name: 'xzjsdz',
    component: function component(resolve) {
      __webpack_require__.e/* require */(7).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(295)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  // 新闻模块
  { //新闻资讯
    path: '/notify',
    name: 'notify',
    component: function component(resolve) {
      __webpack_require__.e/* require */(57).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(291)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //新闻资讯详情
    path: '/notifyDetail',
    name: 'notifyDetail',
    component: function component(resolve) {
      __webpack_require__.e/* require */(56).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(292)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  // 帮助模块
  { //注册协议
    path: '/registerProtocol',
    name: 'registerProtocol',
    component: function component(resolve) {
      __webpack_require__.e/* require */(59).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(287)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //升级规则
    path: '/upLevel',
    name: 'upLevel',
    component: function component(resolve) {
      __webpack_require__.e/* require */(58).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(288)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //积分规则
    path: '/integralRule',
    name: 'integralRule',
    component: function component(resolve) {
      __webpack_require__.e/* require */(60).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(286)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //帮助中心
    path: '/helpCenter',
    name: 'helpCenter',
    component: function component(resolve) {
      __webpack_require__.e/* require */(63).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(283)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //帮助中心大类
    path: '/helpType',
    name: 'helpType',
    component: function component(resolve) {
      __webpack_require__.e/* require */(62).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(284)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //帮助中心详情
    path: '/helpDetail',
    name: 'helpDetail',
    component: function component(resolve) {
      __webpack_require__.e/* require */(61).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(285)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //考试入口
    path: '/examEntry',
    name: 'examEntry',
    component: function component(resolve) {
      __webpack_require__.e/* require */(64).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(279)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //独立考试
    path: '/indepenceExam',
    name: 'indepenceExam',
    component: function component(resolve) {
      __webpack_require__.e/* require */(27).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(282)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //班级考试考试查询
    path: '/classExamSearch',
    name: 'classExamSearch',
    component: function component(resolve) {
      __webpack_require__.e/* require */(29).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(278)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //考试记录
    path: '/examHistory',
    name: 'examHistory',
    component: function component(resolve) {
      __webpack_require__.e/* require */(28).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(280)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //试卷预览
    path: '/examPaperScan',
    name: 'examPaperScan',
    component: function component(resolve) {
      __webpack_require__.e/* require */(43).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(281)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //领取奖学金
    path: '/subsidies',
    name: 'subsidies',
    component: function component(resolve) {
      __webpack_require__.e/* require */(67).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(344)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //考试规则
    path: '/examRule',
    name: 'examRule',
    component: function component(resolve) {
      __webpack_require__.e/* require */(65).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(273)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //考试
    path: '/paper',
    name: 'paper',
    component: function component(resolve) {
      __webpack_require__.e/* require */(19).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(275)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //提交试卷提示
    path: '/submitPaper',
    name: 'submitPaper',
    component: function component(resolve) {
      __webpack_require__.e/* require */(42).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(277)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //试卷练习
    path: '/paperPractice',
    name: 'paperPractice',
    component: function component(resolve) {
      __webpack_require__.e/* require */(18).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(276)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //练习列表
    path: '/paperList',
    name: 'paperList',
    component: function component(resolve) {
      __webpack_require__.e/* require */(12).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(274)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, { //默认指向
    path: '*',
    redirect: '/'
  }]
}));

/***/ }),

/***/ 93:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(103);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
	state: {
		certTest: {}, //证书查验
		xsMsg: {}, //学时证明信息
		addrNum: "", //地区选择组件选择的地区编号
		codeNum: 0, //验证码刷新
		showBackBtn: true, //头部是否显示返回按钮
		backToMember: false, //返回个人中心
		navOnBottomStatus: [], //底部导航栏显示状态
		checkBoxAll: false, //设置多选框全选状态   默认false取消全选 
		clickCheckBoxAll: false, //多选框状态单独设置 
		chooseCity: '', //选择的城市
		needPay: '0', //需要支付的价格  
		chooseMajor: "" //选择的专业  
	},
	getters: {
		// 证书模块
		zsData: function zsData(state) {
			// 将证书的数据取出并且转化为对象
			if (state.certTest == "") return JSON.parse(state.certTest);else return JSON.parse(sessionStorage.getItem("zsData"));
		},
		xsData: function xsData(state) {
			// 将证书的数据取出并且转化为对象
			if (state.xsMsg == "" || state.xsMsg == null) return JSON.parse(state.xsMsg);else return JSON.parse(sessionStorage.getItem("xsMsg"));
		}
	},
	mutations: {
		// 证书模块
		zsSave: function zsSave(state, data) {
			state.certTest = data;
			// 将数据存在localstorage，防止刷新没有数据
			sessionStorage.setItem("zsData", data);
		},
		xsSave: function xsSave(state, data) {
			state.xsMsg = data;
			// 将数据存在localstorage，防止刷新没有数据
			sessionStorage.setItem("xsMsg", data);
		},


		// 地区选择
		addrSelectSave: function addrSelectSave(state, data) {
			state.addrNum = data;
		},


		//验证码刷新
		codeFresh: function codeFresh(state) {
			state.codeNum++;
		},


		//头部是否显示返回按钮，默认显示
		showHeaderBack: function showHeaderBack(state, data) {
			state.showBackBtn = data;
		},

		//头部是否返回个人中心
		setBackToMember: function setBackToMember(state, data) {
			state.backToMember = data;
		},


		// 设置底部导航栏状态
		setNavOnBottomStatus: function setNavOnBottomStatus(state, data) {
			state.navOnBottomStatus = data;
		},


		// 设置多选框是否全选
		setCheckBoxAll: function setCheckBoxAll(state, data) {
			state.checkBoxAll = data;
		},
		setClickCheckBoxAll: function setClickCheckBoxAll(state, data) {
			state.clickCheckBoxAll = data;
		},


		//设置选中的城市
		setChooseCity: function setChooseCity(state, data) {
			state.chooseCity = data;
		},


		//需要支付的价格
		setNeedPay1: function setNeedPay1(state, data) {
			state.needPay = data;
		},


		//选择的专业
		setMajor: function setMajor(state, data) {
			state.chooseMajor = data;
		}
	}
});
/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ 95:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 96:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(19)(
  /* script */
  __webpack_require__(125),
  /* template */
  __webpack_require__(175),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(19)(
  /* script */
  __webpack_require__(126),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 99:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	// baseURL:'http://192.168.1.103:8082/', //168
	//	baseURL:'http://192.168.1.192:8080/api',   //陈勇
	//  baseURL:'http://110.cs.gc80.cn',   //陈勇
	baseURL: 'https://m-jxjy.18jobs.com/api', //正式
	// baseURL:'http://weixin.ahsjxjy.com/api',         //微信支付测试
	method: 'POST',
	headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	transformRequest: [function (data) {
		var ret = '';
		for (var it in data) {
			ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&';
		}
		return ret;
	}],
	timeout: 20000
});

/***/ })

},[127]);


// WEBPACK FOOTER //
// static/js/app.042503348a8de8b3e1a9.js